// extracted by mini-css-extract-plugin
export default {"base":"index-module--base--d4f47","rotate":"index-module--rotate--d3979"};